import customFetch from './customFetch';

export function login(data) {
    const option = {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        body: data,
        withCredentials: true,
    };
    return customFetch('/api/login', option);
}

function urlParaString(paras) {
    if (!paras) {
        return '';
    }
    let pString = '';
    let tempPara = '?';
    Object.keys(paras).forEach(key => {
        if (paras[key] !== null) {
            tempPara += key + '=' + paras[key] + '&';
        }
    });
    if (tempPara.length > 1) {
        pString = tempPara.substr(0, tempPara.length - 1);
    }
    return pString;
}

function bodyParaString(paras) {
    let realPara = null;
    if (paras && Object.keys(paras).length > 0) {
        realPara = JSON.stringify(paras);
    }
    return realPara;
}

const doGETRequest = (url, token) => {
    const params = token
        ? {
              'X-Auth-Token': token || null,
              'X-PLATFORM': 'H5',
          }
        : {
              'X-PLATFORM': 'H5',
          };
    let reqUrl = url;
    const option = {
        method: 'GET',
        headers: params,
        withCredentials: true,
    };
    return customFetch(reqUrl, option);
};

const doPOSTRequest = (url, options, token) => {
    console.log(options, 'optionsoptions');
    const params = token
        ? {
              'Content-Type': 'application/json; charset=UTF-8',
              'X-Auth-Token': token || null,
              'X-PLATFORM': 'H5',
          }
        : {
              'Content-Type': 'application/json; charset=UTF-8',
              'X-PLATFORM': 'H5',
          };
    const option = {
        method: 'POST',
        headers: params,
        data: options,
        withCredentials: true,
    };
    return customFetch(url, option);
};

const doPUTRequest = (url, options, token) => {
    const params = token
        ? {
              'Content-Type': 'application/json; charset=UTF-8',
              'X-Auth-Token': token || null,
              'X-PLATFORM': 'H5',
              'Access-Control-Allow-Origin': '*',
          }
        : {
              'Content-Type': 'application/json; charset=UTF-8',
              'X-PLATFORM': 'H5',
              'Access-Control-Allow-Origin': '*',
          };
    const option = {
        method: 'PUT',
        headers: params,
        data: options,
        withCredentials: true,
    };
    return customFetch(url, option);
};

const doDELETERequest = (url, options, token) => {
    const params = token
        ? {
              'Content-Type': 'application/json; charset=UTF-8',
              'X-Auth-Token': token || null,
              'X-PLATFORM': 'H5',
              'Access-Control-Allow-Origin': '*',
          }
        : {
              'Content-Type': 'application/json; charset=UTF-8',
              'X-PLATFORM': 'H5',
              'Access-Control-Allow-Origin': '*',
          };
    const option = {
        method: 'DELETE',
        headers: params,
        data: options,
        withCredentials: true,
    };
    return customFetch(url, option);
};

const doPOSTFileRequest = (url, file, token) => {
    const params = token
        ? {
              // 'Content-Type': 'multipart/form-data; charset=UTF-8',
              'X-Auth-Token': token || null,
              'X-PLATFORM': 'H5',
              'Access-Control-Allow-Origin': '*',
          }
        : {
              // 'Content-Type': 'multipart/form-data; charset=UTF-8',
              'X-PLATFORM': 'H5',
              'Access-Control-Allow-Origin': '*',
          };
    const option = {
        method: 'POST',
        headers: params,
        body: file,
        credentials: 'include',
        mode: 'no-cors',
    };
    return customFetch(url, option);
};

const api = {
    doGETRequest,
    doPOSTRequest,
    doPUTRequest,
    doDELETERequest,
    doPOSTFileRequest,
};

export default api;
